/**
 * Created by Darius on 2016.07.18.
 */
import React, {Component} from "react";
import {Link} from "react-router";
import {connect} from "react-redux";
import {AppBar, Drawer, MenuItem} from "material-ui";

class SideMenu extends Component {
    constructor(props, context) {
        super(props, context);
        this.onRequestChange = this.onRequestChange.bind(this);
        this.openSideMenu = this.openSideMenu.bind(this);
    }

    openSideMenu(event) {
        this.props.openSideMenu();
    }

    onRequestChange() {
        this.props.closeSideMenu();
    }

    render() {
        const {showSideMenu} = this.props;

        return (
            <Drawer open={showSideMenu} docked={false} onRequestChange={this.onRequestChange}>
                <AppBar showMenuIconButton={false} title="Menu"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/dashboard"/>} primaryText="Dashboard"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/templates"/>} primaryText="Templates"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/members"/>} primaryText="Members"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/roles"/>} primaryText="Roles"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/feed-sources"/>} primaryText="Feed Sources"/>
                <MenuItem onTouchTap={this.onRequestChange} containerElement={<Link to="/chat-archive"/>} primaryText="Chat Archive"/>
            </Drawer>
        );
    }
}

const mapStateToProps = state => ({
    showSideMenu: state.common.showSideMenu || false
});

const mapDispatchToProps = dispatch => ({
    openSideMenu: () =>
        dispatch({type: 'OPEN_SIDE_MENU', payload: true}),
    closeSideMenu: () =>
        dispatch({type: 'OPEN_SIDE_MENU', payload: false})
});

SideMenu = connect(mapStateToProps, mapDispatchToProps)(SideMenu);

export default SideMenu;